import { absolutePath } from "./absolutePath";

export interface UserSessionIndexParams {
  page?: number;
  per_page?: number;
}

export const accountAuthentication = {
  connectedAccount: {
    index: () => absolutePath(`account/authentication/connected_accounts`, {}),
    delete: ({ id }: { id: string }) =>
      absolutePath(`account/authentication/connected_accounts/${id}`, {}),
  },
  userSession: {
    index: (params: UserSessionIndexParams = {}) =>
      absolutePath(`account/authentication/user_sessions`, params),
    revoke: (id: number) =>
      absolutePath(`account/authentication/user_sessions/${id}/revoke`, {}),
    revokeAll: () =>
      absolutePath(`account/authentication/user_sessions/revoke_all`, {}),
  },
  users: {
    update: () => absolutePath(`account/authentication/users`, {}),
  },
};
